interface VerticalSeparatorProps {
  height?: string
}

export const VerticalSeparator: React.FC<VerticalSeparatorProps> = ({
  height = '24',
}) => {
  return (
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      width={'2'}
      height={height}
      viewBox={'0 0 2 60'}
      fill={'none'}
    >
      <path d={'M1 0V60'} stroke={'#D9D9D9'} />
    </svg>
  )
}
